import React from 'react';
import { KText } from '@/ui-library/components/text';
import { Link } from 'react-router-dom';
import { Button, Flex, Heading } from '@chakra-ui/react';
import { CenterSpinner } from '@/components/ats';
import { ReportTypes } from '../../../types';

export const ReportBoundary = ({
  reportData,
}: {
  reportData: ReportTypes.ReportMeta;
}) => {
  const { layoutData: report, type, isLoading, error } = reportData ?? {};
  const hasInvalidReport = !report || type === 'invalid';

  if (hasInvalidReport || error) {
    const heading = hasInvalidReport
      ? 'Report not found'
      : 'Something went wrong';
    const message = hasInvalidReport
      ? 'The requested report could not be found'
      : typeof error === 'string'
      ? error
      : 'Unknown error';

    if (isLoading) {
      return (
        <Flex w="100%" h="100%" alignItems="center" justifyContent="center">
          <CenterSpinner />
        </Flex>
      );
    }

    return (
      <Flex
        w="100%"
        h="100%"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
      >
        <Heading as="h1" fontSize="2xl" mb="4">
          {heading}
        </Heading>
        <KText mb="4">{message}</KText>
        <Link to="/reports">
          <Button variant="ats-primary">Go back to Reports</Button>
        </Link>
      </Flex>
    );
  }
};
